import React from "react";
import styles from "./style.module.css";
import { images } from "../../../../assets/images";

const EventsCard = () => {
  const { EventBig, EventSmall } = images;
  const imageData = [
    { imageName: EventSmall, bigImage: false },
    { imageName: EventSmall, bigImage: false },
    { imageName: EventBig, bigImage: true },
    { imageName: EventSmall, bigImage: false },
    { imageName: EventBig, bigImage: true },
    { imageName: EventSmall, bigImage: false },
    { imageName: EventSmall, bigImage: false },
    { imageName: EventBig, bigImage: true },
    { imageName: EventSmall, bigImage: false },
  ];

  const smallImages = imageData.filter((image) => !image.bigImage);
  const smallImagePairs = [];
  for (let i = 0; i < smallImages.length; i += 2) {
    smallImagePairs.push(smallImages.slice(i, i + 2));
  }
  const bigImages = imageData.filter((image) => image.bigImage);

  const interleavedImages = [];
  smallImagePairs.forEach((pair, index) => {
    interleavedImages.push(pair);
    if (bigImages[index]) {
      interleavedImages.push([bigImages[index]]);
    }
  });

  return (
    <div className={styles.container}>
      <div
        className={`${styles.innerContainer} ${
          imageData.length <= 5 ? styles.innerContainerPadding : ""
        }`}
      >
        {interleavedImages.map((group, groupIndex) => (
          <div key={groupIndex} className={styles.topContainer}>
            {group.map((image, imageIndex) => (
              <img
                key={imageIndex}
                src={image.imageName}
                alt={image.imageName}
              />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${styles.innerContainer} ${
          imageData.length < 4 ? styles.innerContainerPadding : ""
        }`}
      >
        {interleavedImages.map((group, groupIndex) => (
          <div key={groupIndex} className={styles.topContainer}>
            {group.map((image, imageIndex) => (
              <img
                key={imageIndex}
                src={image.imageName}
                alt={image.imageName}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventsCard;
